import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Settings } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useState } from "react";

const CookieSettingsButton = () => {
  const { consentStatus, acceptCookies, rejectCookies, analyticsEnabled } = useCookieConsent();
  const [open, setOpen] = useState(false);
  const [analyticsChecked, setAnalyticsChecked] = useState(analyticsEnabled);

  const handleSave = () => {
    if (analyticsChecked) {
      acceptCookies();
    } else {
      rejectCookies();
    }
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2 text-xs">
          <Settings className="w-3 h-3" />
          Preferenze Cookie
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Preferenze Cookie</DialogTitle>
          <DialogDescription>
            Gestisci le tue preferenze sui cookie. Puoi modificare queste impostazioni in qualsiasi momento.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          {/* Technical Cookies - Always enabled */}
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <Label htmlFor="technical" className="font-medium">
                Cookie Tecnici
              </Label>
              <p className="text-sm text-muted-foreground">
                Necessari per il funzionamento del sito. Non possono essere disattivati.
              </p>
            </div>
            <Switch id="technical" checked disabled />
          </div>

          {/* Analytics Cookies */}
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <Label htmlFor="analytics" className="font-medium">
                Cookie Analitici
              </Label>
              <p className="text-sm text-muted-foreground">
                Ci aiutano a capire come utilizzi il sito per migliorare l'esperienza utente.
              </p>
            </div>
            <Switch
              id="analytics"
              checked={analyticsChecked}
              onCheckedChange={setAnalyticsChecked}
            />
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => setOpen(false)}>
            Annulla
          </Button>
          <Button onClick={handleSave}>
            Salva Preferenze
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CookieSettingsButton;
